jQuery(document).ready(function($){
  /* Collection Editorial Features */
  if($('.editorial-feature').length) {
    var placement = $('.editorial-feature').attr('data-placement');      

    if(placement) {
      $('.editorial-feature').insertAfter('.productgrid--items li:nth-child(' + placement + ')').addClass('moved');      
    } else {
      $('.editorial-feature').insertAfter('.productgrid--items li:last-child').addClass('moved');      
    }
  }

  /* Gift Guide Midpoint CTA Placement */
  if($('#shopify-section-michi-gift-guide-midpoint-cta').length) {
    var sectionCount = $('#shopify-section-michi-gift-guide-featured-collections > section').length;
    var midPoint = Math.round(sectionCount) / 2;
    var href = $('#shopify-section-michi-gift-guide-midpoint-cta a:first-of-type').attr('href');

    $('#shopify-section-michi-gift-guide-midpoint-cta').insertAfter('#shopify-section-michi-gift-guide-featured-collections > section:nth-child(' + midPoint + ')').addClass('placed');
    $('#shopify-section-michi-gift-guide-midpoint-cta').remove();
    
    $('#shopify-section-michi-gift-guide-featured-collections').children('div[class=""]').addClass('shopify-section placed').attr('id', 'shopify-section-michi-gift-guide-midpoint-cta');
    $('#shopify-section-michi-gift-guide-midpoint-cta a').each(function(){
      $(this).attr('href', href);
    });
  }

  if($('li[data-handle^=price_]').length) {
    let filterArray = [];
    $('li[data-handle^=price_]').each(function(){
      let parentList = $(this).closest('ul');
      let num = $(this).attr('data-handle').match(/\d+/);
      filterArray.push(num[0]);
    });

    filterArray.sort(function(a, b) {
      return a - b;
    });

    for (let i = 0; i < filterArray.length; ++i) {
      $('li[data-handle="price_under' + filterArray[i] + '"]').appendTo('ul.ul-filter-type--price');
    }

  }
});